import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { SugerenciasModel } from '../models/sugerencias.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SugerenciaService extends BaseService<SugerenciasModel>{

  tipo: string;
  urlBase: string;
  constructor(protected httpClient: HttpClient) {
    super(httpClient);

    this.tipo = `Sugerencia`;
    this.urlBase = `${environment.baseApi}${environment.endPoints.sugerencia.base_sugerencia}`;
   }
}
